import React from "react";
import { Route, Routes } from "react-router-dom";

import AllCasesPage from "./case.all.jsx";
import CaseDetailPage from "./case.details.jsx";

const CaseManagement = () => {
  return (
    <Routes>
      <Route element={<CaseDetailPage />} path=":caseId/*" />
      <Route element={<AllCasesPage />} path="/" />
    </Routes>
  );
};

export default CaseManagement;
